import useTestId from '@ori/testid-generator';
import type { FC } from 'react';

import { type SearchPreviewProductProps } from '../../types';
import { SEARCH_PREVIEW_PRODUCT_PRICES } from './constants';
import { Root, CurrentPrice, OldPrice } from './styles';
import { isOldPriceVisible } from './utils';

export type PricesProps = Pick<SearchPreviewProductProps, 'price' | 'code'>;
export const Prices: FC<PricesProps> = ({ price, code }) => {
  const { getTestId } = useTestId();

  if (!price?.currentFormatted) {
    return null;
  }

  const { currentFormatted, oldFormatted } = price;
  const oldPriceVisible = isOldPriceVisible({ currentFormatted, oldFormatted });

  return (
    <Root data-testid={getTestId(`${SEARCH_PREVIEW_PRODUCT_PRICES}-${code}`)}>
      <CurrentPrice
        fontWeight="bold"
        oldPriceVisible={oldPriceVisible}
      >
        {currentFormatted}
      </CurrentPrice>
      {oldPriceVisible ? <OldPrice>{oldFormatted}</OldPrice> : null}
    </Root>
  );
};
